import { Component, OnInit } from '@angular/core';
import ApexCharts from 'apexcharts';
import data from '../../../../assets/json/series.json';
import { ChartService } from 'src/app/services/chart.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MathUtil } from 'src/app/common/util';

@Component({
  selector: 'app-accounting-chart-result',
  templateUrl: './accounting-chart-result.component.html',
  styleUrls: ['./accounting-chart-result.component.scss']
})
export class AccountingChartResultComponent implements OnInit {
  year = null;
  years = [];

  constructor(
    private chartService: ChartService,
    private toastService: ToastrService
  ) {
    this.year = new Date().getFullYear();
    var origin = 2022;
    for (let index = origin; index <= (this.year + 3); index++) {
      this.years.push(index);
    }
  }

  ngOnInit() {
    this.updateChart();
  }

  updateChart() {
    document.getElementById("accounting-chart-result").innerHTML = "";
    var months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    this.chartService.getAccountingResultChart(this.year).subscribe({
      next: (response: ResponseObject) => {
        var expenses = response.data.expenses;
        var incomes = response.data.income;
        console.log(expenses, incomes);
        const options = {
          chart: {
            height: 350,
            type: 'area',
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          series: [{
            name: 'Ingresos',
            data: incomes
          }, {
            name: 'Costos + Gastos',
            data: expenses
          }],
          xaxis: {
            type: 'Mes',
            categories: months,
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return MathUtil.formatCurrency(val);
              }
            }
    
          },
          legend: {
            offsetY: -10,
          }
        }
        const chart = new ApexCharts(
          document.querySelector("#accounting-chart-result"),
          options
        );
        chart.render();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }
}
